import Vue from 'vue'

import AccountAvailableItemCategoriesRepository from '@/repositories/AccountAvailableItemCategoriesRepository'
import AccountRepository from '@/repositories/AccountRepository'
import AccountRepositoryMock from '@/repositories/AccountRepositoryMock'
import AnnouncementRepository from '@/repositories/AnnouncementRepository'
import AnnouncementRepositoryMock from '@/repositories/AnnouncementRepositoryMock'
import CalendarRepository from '@/repositories/CalendarRepository'
import CalendarRepositoryMock from '@/repositories/CalendarRepositoryMock'
import CompanyRepository from '@/repositories/CompanyRepository'
import CompanyRepositoryMock from '@/repositories/CompanyRepositoryMock'
import ItemCategoryRepository from '@/repositories/ItemCategoryRepository'
import ItemCategoryRepositoryMock from '@/repositories/ItemCategoryRepositoryMock'
import ItemCategoryLevelRepository from '@/repositories/ItemCategoryLevelRepository'
import ItemCategoryLevelRepositoryMock from '@/repositories/ItemCategoryLevelRepositoryMock'
import ItemRepository from '@/repositories/ItemRepository'
import ItemRepositoryMock from '@/repositories/ItemRepositoryMock'
import StoreRepository from '@/repositories/StoreRepository'
import StoreRepositoryMock from '@/repositories/StoreRepositoryMock'
import StoreGroupRepository from '@/repositories/StoreGroupRepository'
import StoreGroupRepositoryMock from '@/repositories/StoreGroupRepositoryMock'
import DownloadRequestRepository from '@/repositories/DownloadRequestRepository'
import MouseAccountRepository from '@/repositories/MouseAccountRepository'
import QueryMetadataRepository from '@/repositories/QueryMetadataRepository'
import QueryMetadataRepositoryMock from '@/repositories/QueryMetadataRepositoryMock'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.repositories) this.$repositories = options.repositories
    else if (options.parent && options.parent.$repositories)
      this.$repositories = options.parent.$repositories
  },
})

const masterRepositories = {
  account: AccountRepository,
  calendar: CalendarRepository,
  company: CompanyRepository,
  item: ItemRepository,
  itemCategory: ItemCategoryRepository,
  itemCategoryLevel: ItemCategoryLevelRepository,
  store: StoreRepository,
  storeGroup: StoreGroupRepository,
}

const mouseRepositories = {
  announcement: AnnouncementRepository,
  downloadRequest: DownloadRequestRepository,
  accountAvailableItemCategories: AccountAvailableItemCategoriesRepository,
  mouseAccount: MouseAccountRepository,
  queryMetadata: QueryMetadataRepository,
}

const mockMasterRepositories = {
  account: AccountRepositoryMock,
  calendar: CalendarRepositoryMock,
  company: CompanyRepositoryMock,
  item: ItemRepositoryMock,
  itemCategory: ItemCategoryRepositoryMock,
  itemCategoryLevel: ItemCategoryLevelRepositoryMock,
  store: StoreRepositoryMock,
  storeGroup: StoreGroupRepositoryMock,
}

const mockMouseRepositories = {
  announcement: AnnouncementRepositoryMock,
  queryMetadata: QueryMetadataRepositoryMock,
}

export default {
  get(name) {
    let repository

    if (process.env.VUE_APP_MASTER_API_URL_BASE) {
      repository = masterRepositories[name]
    } else {
      repository = mockMasterRepositories[name]
    }

    if (repository) {
      return repository
    }

    if (process.env.VUE_APP_QUERY_API_URL_BASE) {
      repository = mouseRepositories[name]
    } else {
      repository = mockMouseRepositories[name]
    }

    if (repository) {
      return repository
    }

    throw new Error(`リポジトリ ${name} が見つかりませんでした`)
  },
}
